contractApp.controller('contractChangesCreateModalCtrl', function(
    $scope,
    $state,
    $uibModalInstance,
    ntFlash,
    data,
    contractingService,
    RATIONALE_TYPES,
    loadExternalDataService,
    $timeout
) {
    var contractId = data.contractId;
    $scope.contract = data.contract;
    $scope.tenderCreated = data.tenderCreated
    $scope.procurementMethodType = data.procurementMethodType
    $scope.causeDetails = data.causeDetails?.scheme || null
    $scope.CONTRACT_CHANGE_RATIONALE_TYPES_SET_FROM = new Date('2025-12-04T00:00:00+02:00')
    $scope.law922 = new Date('2022-10-12T00:00:00+02:00')

    $scope.rationaleList = RATIONALE_TYPES
    // $scope.isVisibleTooltips = false;

    // (function () {
    //     $timeout(() => $scope.isVisibleTooltips = true, 300);
    // })()

    $scope.ExternalDataService =   loadExternalDataService;



    $scope.changes = {
        contractNumber: data.contractNumber,
        rationale: '',
        rationaleTypes: [],
    };

    $scope.collectRationaleTypes = function() {
        $scope.changes.rationaleTypes = [];
        $scope.rationaleTypes.forEach(function(type) {
            if (type.checked) {
                $scope.changes.rationaleTypes.push(type.title);
            }
        });
    };

    $scope.createChange = function() {
        $scope.$broadcast('show-errors-check-validity');

        if (!$scope.changeForm.$valid) {
            ntFlash.error(gettext('Заполните обязательные поля (подчеркнуты красным)'));
        } else {
            contractingService.saveChange(contractId, $scope.changes)
            .then(()=>{
                ntFlash.success(gettext('Процесс внесения изменений успешно инициализирован'));
                $uibModalInstance.close();
            });
        }
    };

    $scope.initTooltips = (item) =>{
        if(item) {
            item.info = !item.info
        }
    }


    $scope.close = function() {
        $uibModalInstance.dismiss();
    };
    let rationaleTypes = []
    if($scope.procurementMethodType === 'reporting'){
        if($scope.causeDetails === 'DECREE1178'){
            $scope.ExternalDataService.contract_change_1178()
            .then((changes)=>{
                console.log('contract_change_1178_reporting', changes)
                $scope.rationaleTypes = generateChanges(changes)
            })
        } else {
            $scope.ExternalDataService.contract_change_922()
                .then((changes)=>{
                    console.log('contract_change_922_reporting', changes)
                    $scope.rationaleTypes = generateChanges(changes)
                })
        }
    } else if($scope.contract.contractChangeRationaleTypes && !$scope.causeDetails === 'DECREE1178'){
        console.log('contractChangeRationaleTypes', $scope.contract.contractChangeRationaleTypes)
        $scope.rationaleTypes = generateChanges($scope.contract.contractChangeRationaleTypes)
    } else if( new Date($scope.tenderCreated) > $scope.law922 &&
        $scope.procurementMethodType === 'aboveThreshold') {

        $scope.ExternalDataService.contract_change_1178()
            .then((changes)=>{
                console.log('contract_change_1178', changes)
                $scope.rationaleTypes = generateChanges(changes)
            })
    } else {
        $scope.ExternalDataService.contract_change_922()
            .then((changes)=>{
                console.log('contract_change_922', changes)
                $scope.rationaleTypes = generateChanges(changes)
            })
    }

    function generateChanges(changes) {
        const contractChangeRationaleTypes = Object.entries(changes)
        for(let [key, value] of contractChangeRationaleTypes) {
            if(value.archive) continue;
            const defaultFieldList = "Ціна договору, Ціна договору без ПДВ, Ціна за одиницю, Конкретна назва предмета закупівлі, Інф про номенкл, кі-сть товару, Місце поставки товарів, Дата з якої очікується поставка, Необхідний граничний термін постачання, Дата початку, Дата завершення";

            const current  = RATIONALE_TYPES.find(el => el.title === key)
            rationaleTypes.push({
                checked: false,
                title: key,
                description_en: value.description_en,
                title_en: value.title_en,
                description_uk: value.description_uk,
                title_uk: value.title_uk,
                archive: value.archive,
                changes: current?.changes || defaultFieldList,
                info: false
            })
        }
        return rationaleTypes

    }

    // $scope.rationaleTypes = [
    //     {
    //         checked: false,
    //         title: 'priceReductionWithoutQuantity' // погодження зміни ціни в договорі про закупівлю в бік зменшення (без зміни кількості (обсягу) та якості товарів, робіт і послуг)
    //     },
    //     {
    //         checked: false,
    //         title: 'taxationSystem' // Зміна ціни у зв’язку із зміною ставок податків і зборів
    //     },
    //     {
    //         checked: false,
    //         title: 'externalIndicators' // Зміна сторонніх показників (курсу, тарифів...)
    //     },
    //     {
    //         checked: false,
    //         title: 'itemPriceChange' // погодження зміни ціни за одиницю товару в договорі про закупівлю
    //     },
    //     {
    //         checked: false,
    //         title: 'volumeCuts' // Зменшення обсягів закупівлі
    //     },
    //     {
    //         checked: false,
    //         title: 'itemPriceVariation' // Збільшення ціни за одиницю товару до 10 відсотків
    //     },
    //     {
    //         checked: false,
    //         title: 'qualityImprovement' // Покращення якості предмета закупівлі
    //     },
    //     {
    //         checked: false,
    //         title: 'durationExtension' // Продовження строку дії договору (через документально підтверджені об’єктивні обставини)
    //     },
    //     {
    //         checked: false,
    //         title: 'priceReduction' // Узгоджене зменшення ціни
    //     },
    //     {
    //         checked: false,
    //         title: 'taxRate' // Зміна ціни у зв’язку із зміною ставок податків і зборів
    //     },
    //     {
    //         checked: false,
    //         title: 'thirdParty' // Зміна сторонніх показників (курсу, тарифів...)
    //     },
    //     {
    //         checked: false,
    //         title: 'fiscalYearExtension' // Продовження строку дії договору на наступний рік
    //     }
    // ];

});
